export default __webpack_public_path__ + "static/media/stem.b787fce0.glb";